export default __webpack_public_path__ + "static/media/map_pattern.27ff554b.png";